import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/countries")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Countries")),
  head: () => ({ meta: seo({ title: "Countries" }) }),
});
